<template>
    <div id="sub-content" class="s-inner">
        <h3>연혁</h3>

        <p class="s-txt1 mb70">신뢰의 역사, 도전의 역사<br>한국토지신탁의 전성기는 이제 시작입니다.</p>

        <div class="sub-history-wrap">
            <div class="img-box"><img src="@/assets/images/sHistory_img1.jpg" alt="~Present"></div>
            <div class="sub-history-box">
                <div>
                    <div class="txt-box">
                        <p class="tit">~Present</p>
                        <ul>
                            <li>
                                <p class="year">2025</p>
                                <p class="txt">각자 대표이사 최윤성·김성진 취임</p>
                            </li>
                            <li>
                                <p class="year">2021</p>
                                <p class="txt">각자 대표이사 최윤성·김정선 취임</p>
                            </li>
                            <li>
                                <p class="year">2020</p>
                                <p class="txt">사옥 이전(역삼동 코레이트타워)</p>
                            </li>
                            <li>
                                <p class="year">2017</p>
                                <p class="txt">각자 대표이사 차정훈·최윤성 취임<br><strong>업계 최초 자산 규모 1조원 돌파</strong></p>
                            </li>
                            <li>
                                <p class="year">2016</p>
                                <p class="txt"><strong>코스피 이전상장</strong>, BI/CI 변경<br>KOREIT 자산운용 ((구)마이에셋자산운용(주)) 인수<br><strong>업계 최초 자기자본 5,000 억원 돌파</strong></p>
                            </li>
                            <li>
                                <p class="year">2015</p>
                                <p class="txt">각자 대표이사 차정훈·김두석 취임</p>
                            </li>
                            <li>
                                <p class="year">2014</p>
                                <p class="txt">KOREIT 투자운용 ((구)지이자산관리코리아(주)) 인수</p>
                            </li>
                            <li>
                                <p class="year">2010</p>
                                <p class="txt">기타공공기관 해제</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div class="txt-box">
                        <p class="tit">2001~</p>
                        <ul>
                            <li>
                                <p class="year">2009</p>
                                <p class="txt">PCF Master 신상품 출시</p>
                            </li>
                            <li>
                                <p class="year">2008</p>
                                <p class="txt"><strong>부동산개발업 등록</strong></p>
                            </li>
                            <li>
                                <p class="year">2007</p>
                                <p class="txt">유상증자(자본금 2,525억원)</p>
                            </li>
                            <li>
                                <p class="year">2006</p>
                                <p class="txt">대구지점, 중부지점 폐쇄 및 강원사업단 지점 승격</p>
                            </li>
                            <li>
                                <p class="year">2005</p>
                                <p class="txt">강원사업단 개설</p>
                            </li>
                            <li>
                                <p class="year">2004</p>
                                <p class="txt">대구지점 개설<br>담보부사채신탁업 등록</p>
                            </li>
                            <li>
                                <p class="year">2003</p>
                                <p class="txt">산업은행과 부동산분야의 독점적 자산운용협약 체결<br><strong>정비사업전문관리업 등록</strong></p>
                            </li>
                            <li>
                                <p class="year">2002</p>
                                <p class="txt">K1 CR-REIT설립 본인가 승인, 중부지점 개설<br>코아루 브랜드 런칭</p>
                            </li>
                            <li>
                                <p class="year">2001</p>
                                <p class="txt"><strong>국내 최초 부동산투자회사법에 의한 자산관리회사 겸업 인가<br>코스닥 등록</strong></p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div class="txt-box">
                        <p class="tit">Since 1996</p>
                        <ul>
                            <li>
                                <p class="year">1999</p>
                                <p class="txt">일반공모 및 한국토지공사 증자(자본금 1,800억원)</p>
                            </li>
                            <li>
                                <p class="year">1997</p>
                                <p class="txt">한국토지공사 증자(자본금 500억원)<br>광주지점 개설<br>부산지점 개설</p>
                            </li>
                            <li>
                                <p class="year">1996</p>
                                <p class="txt"><strong>영업개시</strong><br>한국토지공사 전액출자로 설립(자본금 300억원)<br><strong>부동산신탁회사 설립인가(재정경제원장관, 신탁업법 제 3조)</strong></p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <p class="s-txt2 tr mt20">※ 재무정보는 연결기준 작성</p>
    </div>
</template>
<script>
export default {
    setup() {
        
    },
}
</script>